import Header from './components/Header';
import HeroSection from './components/HeroSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <AboutSection />
        <CommentsSection />
        <CarouselSection />
        <ContactSection />
        <MediaSection />
        <FeaturesSection />
        <AppSection />
        <UpdatesSection />
        <TopicsSection />
        <CardsSection />
        <RankingSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}